import React from "react";

import { Grid, GridCol } from "../../../../components/Grid";
import { Card } from "../../components/Card";
// components
import { Layout, Row } from "../../components/Layout";

// config
import Config from "../../Config";
import CurrentSurveryPeriod from "./Cards/CurrentSurveyPeriodKPI";
import ParticipationSummary from "./Cards/ParticipationSummary";
import QuestionCompletionKPI from "./Cards/QuestionCompletionKPI";
import QuestionsTable from "./Cards/QuestionsTable";

const questionsConfig = Config.QUESTIONS;

const Questions = () => {
	return (
		<Layout title="Questions" topAreaMaxHeight={224}>
			<Row height={questionsConfig.ROW_HEIGHTS[0]}>
				<Grid gap={2} cols={12} padding={0}>
					<GridCol span={4}>
						<Card padX={16} height={questionsConfig.ROW_HEIGHTS[0]}>
							<CurrentSurveryPeriod />
						</Card>
					</GridCol>
					<GridCol span={4}>
						<Card padX={16} height={questionsConfig.ROW_HEIGHTS[0]}>
							<ParticipationSummary />
						</Card>
					</GridCol>
					<GridCol span={4}>
						<Card padX={16} height={questionsConfig.ROW_HEIGHTS[0]}>
							<QuestionCompletionKPI />
						</Card>
					</GridCol>
				</Grid>
			</Row>
			<Row height={questionsConfig.ROW_HEIGHTS[1]} />
			<Row height={questionsConfig.ROW_HEIGHTS[2]}>
				<div>
					<Grid gap={2} cols={12} padding={0}>
						<GridCol span={12}>
							<Card minHeight={questionsConfig.ROW_HEIGHTS[2]}>
								<QuestionsTable />
							</Card>
						</GridCol>
					</Grid>
				</div>
				<Row height={56} />
			</Row>
		</Layout>
	);
};

export default Questions;
